import React, {useContext} from 'react';
import GettingStartedContext from "../utils/GettingStartedContext";

const HelpButton = () => {

  const {
    data
  } = useContext(GettingStartedContext)

  const showHelpForm = () => {
    const helpDiv = document.getElementById('gsa-help');
    if (helpDiv) {
      helpDiv.classList.toggle("active");
      LiveChatWidget.call('minimize');
    }
  }

  return <li onClick={showHelpForm}>
    <a href="#" onClick={(e) => e.preventDefault()}>
      <img src="_resources/themes/airsprint/images/gsa/need-help-icon.svg" />
      {data.HelpText}
    </a>
  </li>

}

export default HelpButton;
